



















































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop ,Watch } from "vue-property-decorator";
import question from '../../../components/question.vue'
import {PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import noImg from '@/assets/img/common/no-img.svg';
import phoneCode from '@/assets/js/phone_code.js';
import Tanchuan from '@/assets/img/common/tanchuan.svg';
import { getCompanyInfo } from "@/model/CompanyInfo";
import EventBus from '@/utils/eventBus';
import { CUSTOM_POPPINS_FONT_COMPANY_ID, CUSTOM_TENOR_SANS_FONT_COMPANY_ID } from "@/utils/getFontFaceList";
import { isEnableWheelCouponSetting, isEnablePrivacySetting, isEnableExtendedPopCountdown, isEnableBannerEnglishPunctuationSpacing, isEnableCloseButtonAdvanced } from '@/utils/experiment';
import ExtendedCountdown from '@/components/wheel/ExtendedCountdown.vue';
import CloseButtonPreviewIcon from './CloseButtonPreviewIcon.vue';


@Component({
  components: {
    'component-question':question,
    ExtendedCountdown,
    CloseButtonPreviewIcon,
  },
})
export default class pop extends Vue {
  @Prop(String)
  activePageSetting!:string;

  @Prop(Number)
  triggerEventType!:any

  @Prop(Object)
  formData!:PopSettingsVO;

  @Prop(String)
  couponCopyText!:string;

  @Prop(String)
  device!:string;

  @Prop(Array)
  countryList!:any

  @Prop(String)
  id?:any;

  @Prop(Number)
  templateId?:Number

  @Prop(Number)
  popWindowWheel?: Number;

  @Prop({ type: String, default: 'success' })
  subscribeStatus!: string;

  @Prop({ type: String, default: '1' })
  step!: string;

  noImg = noImg;
  countDownM:string ='05'
  countDownS:string ='00'

  imgNameObj ={
    "LeftTop":{ top: '20px', left: '20px'},
    "RightTop":{ top: '20px', right: '20px'},
    "LeftMiddle":{top: '47%', left: '20px'},
    "RightMiddle":{top: '47%', right: '20px'},
    "LeftBottom":{bottom: '20px', left: '20px'},
    "RightBottom":{bottom: '20px', right: '20px'},
  }
  Email = ''
  public img = {
    Tanchuan
  }

  imgWidth = '100%';
  imgHeight = 'auto';

  iconDynamicSizing = false;

  selectedCountry = {
    countryAbbreviation: 'US',
    phoneCode: '+1'
  }
  value1 = ''
  checkList = []

  discountTypeUpdated = 0;

  startOrEnd = this.formData.start || []
  formDataStart: any = this.formData
  async created(): Promise<void> {
    this.formData.position.iconShow = this.formData.position.iconShow || true;
  }

  get enableFormOptimize() {
    return true;
  }

  get enableTenorSansFontFamily() {
    return CUSTOM_TENOR_SANS_FONT_COMPANY_ID.includes(getCompanyInfo().id || 0);
  }

  get enablePopinsFontFamily() {
    return CUSTOM_POPPINS_FONT_COMPANY_ID.includes(getCompanyInfo().id || 0);
  }

  get enableWheelCouponSetting() {
    return isEnableWheelCouponSetting() && this.formData.discountList && this.popWindowWheel === 1;
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  /** 老渲染链路是否启用扩展倒计时组件（只有当 countdown 数据存在时才渲染新组件） */
  get enableExtendedCountdownPreviewOld() {
    return (
      isEnableExtendedPopCountdown() &&
      !!this.formData.countdown &&
      this.formData.rules.countDownShow
    );
  }

  get enableBannerEnglishPunctuationSpacing() {
    return isEnableBannerEnglishPunctuationSpacing();
  }

  /** 与 C 端一致：开启关闭按钮高级设置且非嵌入式弹窗时，预览使用 cartx-b-close-v2 + SVG scale */
  get enableClosePreviewV2() {
    return isEnableCloseButtonAdvanced() && this.triggerEventType !== 7;
  }

  // 获取当前页面的关闭按钮完整配置
  get currentCloseButtonConfig() {
    const rules = this.formData.rules;
    const cover = this.formData.cover;
    let config = null;

    // 根据页面类型获取对应的 closeButtonConfig
    if (this.activePageSetting === 'cover') {
      config = cover && cover.closeButtonConfig;
    } else if (this.activePageSetting === 'end') {
      config = rules.endCloseButtonConfig;
    } else if (this.activePageSetting === 'middle') {
      config = rules.middleCloseButtonConfig;
    } else if (this.activePageSetting === 'start') {
      config = rules.closeButtonConfig;
    }

    // 老配置字段是表单（非灰度店铺）实际写入的目标
    let oldColor: string | undefined;
    if (this.activePageSetting === 'cover') {
      oldColor = (cover && cover.closeColor) || rules.closeColor;
    } else if (this.activePageSetting === 'end') {
      oldColor = rules.endCloseColor || rules.closeColor;
    } else if (this.activePageSetting === 'middle') {
      oldColor = rules.middleCloseColor || rules.closeColor;
    } else {
      oldColor = rules.closeColor;
    }

    // 非灰度店铺：表单只写老字段，优先以老字段为准（避免被 pop/index.vue 迁移生成的
    // closeButtonConfig.iconColor 冻结住颜色，导致用户改色不生效）
    // 灰度店铺：表单写新字段并同步回老字段，优先用新字段
    const newColor = config && config.iconColor;
    const iconColor = isEnableCloseButtonAdvanced()
      ? (newColor || oldColor)
      : oldColor;

    return {
      iconColor: iconColor || '#463C32',
      size: (config && config.size) || '18px',
      position: (config && config.position) || 'right-top',
      bgMode: (config && config.bgMode) || 'none',
      bgColor: (config && config.bgColor) || 'rgba(0,0,0,0)',
    };
  }

  get closeColor() {
    // 优先使用新配置的 iconColor
    return this.currentCloseButtonConfig.iconColor;
  }

  // 关闭按钮尺寸（数字）
  get closeButtonSize() {
    return parseInt(this.currentCloseButtonConfig.size, 10);
  }

  // 关闭按钮外层样式 - 按照设计规范：热区=配置尺寸，icon等比缩小居中，位置固定6px
  get closeButtonStyle() {
    const config = this.currentCloseButtonConfig;
    const sizeNum = this.closeButtonSize; // 热区尺寸（18px-40px）
    const hasBg = config.bgMode !== 'none';

    // 基础样式 - 热区尺寸严格等于配置值
    const style: Record<string, string> = {
      position: 'absolute',
      top: '6px',
      zIndex: '10',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      width: `${sizeNum}px`,
      height: `${sizeNum}px`,
    };

    if (this.enableClosePreviewV2) {
      style.boxSizing = 'border-box';
    }

    // 位置 - 固定6px，不随尺寸变化
    if (config.position === 'left-top') {
      style.left = '6px';
    } else {
      style.right = '6px';
    }

    // 背景样式（v2 背景由 SVG 内部绘制）
    if (hasBg && !this.enableClosePreviewV2) {
      style.backgroundColor = config.bgColor;
      if (config.bgMode === 'circle') {
        style.borderRadius = '50%';
      } else if (config.bgMode === 'square') {
        style.borderRadius = '4px';
      }
    }

    return style;
  }

  // icon尺寸 - 基于热区等比缩小（18px热区对应9.45px icon，比例约0.525）
  get closeIconSize() {
    const sizeNum = this.closeButtonSize;
    return sizeNum;
  }

  get iconStyles() {
    const {
      device,
      iconDynamicSizing
    } = this;

    // console.log('iconStyles before', JSON.stringify({
    //   device,
    //   iconWidth: this?.formData?.position?.iconWidth || '',
    //   iconDynamicSizing
    // }));

    if (!iconDynamicSizing) {
      // console.log('iconStyles', this.formData.position?.position, JSON.stringify(this.imgNameObj[this.formData.position?.position]));
      return this.imgNameObj;
    }

    let leftOrRight = '20px';
    if (this.device === 'phone') {
      leftOrRight = '0px';
    } else {
      leftOrRight = '20px';
    }

    // 动态尺寸icon固定100px 对齐C端
    let topOrBottom = '100px';

    // console.log('iconStyles', JSON.stringify({device, iconDynamicSizing, topOrBottom, leftOrRight}));
    return {
      "LeftTop":{top: topOrBottom, left: leftOrRight},
      "RightTop":{top: topOrBottom, right: leftOrRight},
      "LeftMiddle":{top: '47%', left: leftOrRight},
      "RightMiddle":{top: '47%', right: leftOrRight},
      "LeftBottom":{bottom: topOrBottom, left: leftOrRight},
      "RightBottom":{bottom: topOrBottom, right: leftOrRight},
    };
  }

  get iconSize() {
    const { device, iconDynamicSizing } = this;
    let width = this?.formData?.position?.iconWidth || '';
    let height = this?.formData?.position?.iconHeight || '';

    // console.log('iconSize before', JSON.stringify({
    //   device,
    //   iconDynamicSizing,
    //   iconSizeType: this.formData.position?.iconSizeType,
    //   width,
    //   height
    // }));

    if (this.formData.position?.iconSizeType) {
      switch (this.formData.position?.iconSizeType) {
        case 'Small':
         width = 30;
          break;
        case 'Medium':
          width = 50;
          break;
        case 'Big':
          width = 80;
          break;
        default:
          width = 50;
          break;
      }
    }

    if (iconDynamicSizing) {
      switch (this.formData.position?.iconSizeType) {
        case 'Small':
          width = device === 'phone' ? 28 : 40;
          break;
        case 'Medium':
          width = device === 'phone' ? 35 : 50;
          break;
        case 'Big':
          width = device === 'phone' ? 46 : 65;
          break;
        default:
          width = device === 'phone' ? 35 : 50;
          break;
      }
    }

    // console.log('iconSize', JSON.stringify({
    //   device,
    //   iconDynamicSizing,
    //   iconSizeType: this.formData.position?.iconSizeType,
    //   width,
    //   height
    // }));

    return {
      width,
      height
    }
  }

  get currentPrivateHideCheckout() {
    return true;
    // const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    // return (companyId === 30 ||companyId === 565);
    // return false;
  }

  get currentSubscribeStatus() {
    // 默认显示订阅成功状态
    return this.subscribeStatus || 'success';
  }

  changeCountryCode(v) {
    this.selectedCountry.phoneCode = v.phoneCode;
    this.selectedCountry.countryAbbreviation = v.countryAbbreviation;
  }

  shouldRenderFormItem(item: any) {
    if (!item) return false;
    if (item.type === 'Email') {
      return !this.enablePrivacySetting || !this.formData.rules.stepDisplay || (this.formData.rules.stepDisplay && this.step === '1');
    }
    if (item.type === 'Mobile Number') {
      return !this.enablePrivacySetting || !this.formData.rules.stepDisplay || (this.formData.rules.stepDisplay && this.step === '2');
    }
    if (item.type === '自定义' && !item.optionList?.[0] && item.questionType !== 'Date' && item.questionType !== 'Dropdown') {
      return false;
    }
    return true;
  }

  getFlagLocal(code:string) {
    if (typeof code == 'string') {
      const flag = phoneCode.find((item: any) => {
        return `+${item.CODE}` == code;
      });
      if (flag) {
        return `${flag.LOCAL}`.trim().toLocaleLowerCase();;
      }
      return '';
    } else {
      return (code?.countryAbbreviation ?? '').trim().toLocaleLowerCase();
    }
  }

  @Watch("formData.position.iconUrl")
  calculateSize(newval: string) {
    // console.log('formData.position.iconUrl', newval);
    if (newval) {
      const img = new Image();
      img.src = newval;
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        // console.log('calculateSize aspect ratio:', width, height, width / height);
        const ratio = width / height;
        if (ratio < 0.7) {
          this.iconDynamicSizing = true;
          // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
        } else {
          this.iconDynamicSizing = false;
          // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
        }
      };
    } else {
      this.iconDynamicSizing = false;
      // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
    }
  }

  @Watch("formData.rules.countDown")
  countDownChange(newval:number){
    if (newval >= 60) {
      let m  = newval / 60
      this.countDownS = '00'
      this.countDownM = String(m).length > 1 ? String(m) : '0'+String(m)
    }else{
      this.countDownS = String(newval).length > 1 ? String(newval) : '0'+String(newval)
      this.countDownM = '00'
    }
  }
  @Watch("formData.start",{immediate: true, deep:true})
  startChange(newval:number){
    if(this.activePageSetting ==='start'){
      this.startOrEnd = newval
      if(this.startOrEnd){
        this.startOrEnd.forEach(element => {
          if(element.type == 'Mobile Number'){
            if(element.phoneCountryAbbreviation){
              this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
            }
            if(element.phoneCode){
              this.selectedCountry.phoneCode = element.phoneCode;
            }
          }
        })
      }
    }
  }
  @Watch("formData.end",{immediate: true, deep:true})
  endChange(newval:number){
    if(this.activePageSetting ==='end'){
      this.startOrEnd = newval
      if(this.startOrEnd){
        this.startOrEnd.forEach(element => {
          if(element.type == 'Mobile Number'){
            if(element.phoneCountryAbbreviation){
              this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
            }
            if(element.phoneCode){
              this.selectedCountry.phoneCode = element.phoneCode;
            }
          }
        })
      }
    }
  }
  @Watch("activePageSetting")
  activePageSettingChange(newval:number){
    if(this.activePageSetting ==='end'){
      this.startOrEnd = this.formData.end
    }else if(this.activePageSetting ==='start'){
      this.startOrEnd = this.formData.start
    }
    if(this.startOrEnd){
      this.startOrEnd.forEach(element => {
        if(element.type == 'Mobile Number'){
          if(element.phoneCountryAbbreviation){
            this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
          }
          if(element.phoneCode){
            this.selectedCountry.phoneCode = element.phoneCode;
          }
        }
      })
    }
  }

  get bannerStyle(){
    let style = {
      'background': `${this.formData.banner.backgroundColor}`,
      'color': `${this.formData.banner.textColor}`,
      'font-size': `${this.formData.banner.fontSize}`,
      'font-family': `${this.formData.banner.font}`
    }
    style[this.formData.banner.position] = 0
    return style
  }

  get companyIs450() {
    // 方法不再调用，全量打开加购悬浮窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return companyId === 450 || companyId === 30 || companyId === 313 || companyId === 721 || companyId == 583 || companyId === 608;
  }

  get companyIs475() {
    // 方法不再调用，全量打开加购悬浮窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return companyId === 475 || companyId === 30  || companyId === 902 || companyId === 965 || companyId === 627 || companyId === 571 || companyId === 320 || companyId === 494 || companyId === 475  || companyId === 896 || companyId === 631 || companyId === 1064 || companyId === 455;
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.templateId}`;
    return this.popWindowWheel === 1 || tid === '36' || tid === '37' || tid === '38' || tid === '39' || tid === '40' || tid === '42' || tid === '43' || `${this.id}` === '1e1609bc024d4517989039886ac7ed34' || `${this.id}` === 'abdac5d809824d8280ffff395a854a15';
  }

  get getCombinateType() {
    return (this.formData?.combinationType === 2 || `${this.id}` === 'f5210286e39243b5a296688eaa828f4e');
  }

  get couponPrompt() {
    if (this.formData.discountList && Array.isArray(this.formData.discountList)) {
      // 查找第一个概率大于0的折扣项，返回其提示文案
      const item = this.formData.discountList.find(item => Number(item.rate) > 0);
      return item && item.couponPrompt ? item.couponPrompt : '';
    }
    return this.formData.texts.couponPrompt || '';
  }

  get currentCouponCode() {
    // 使用但不返回这个变量，让计算属性依赖它
    const _ = this.discountTypeUpdated;

    if (this.formData.discountList) {
      const item = this.formData.discountList.find((item: any) => item.rate > 0);

      if (item?.discountType === 2 && !!item.discount) {
        return '动态显示折扣码';
      } else {
        return item?.coupon || 'coupon code';
      }
    }

    // console.log('currentCouponCode', this.formData.discountType, this.formData.discount);
    if (this.formData.discountType === 'dongtai' || !!this.formData.discount) {
      return '动态显示折扣码';
    }
    const couponCode = this.formData.rules.couponCode || 'coupon code';
    return couponCode;
  }
  get currentCouponCopy() {
    return this.couponCopyText || 'Copy';
  }

  get bannerDisplayText() {
    const separator = this.enableBannerEnglishPunctuationSpacing ? ', ' : ',';
    const colon = this.enableBannerEnglishPunctuationSpacing ? ': ' : ':';
    return `${this.formData.banner.bannerName || ''}${separator}CODE${colon}${this.currentCouponCode}`;
  }

  defineUrl(url){
    if(url.indexOf('https://') == -1 && url.indexOf('http://') == -1){
      return 'http://' + url
    }else {
      return url
    }
  }

  getTimeNumberString(num:any) {
    if (Number(num) < 10) {
      return `0${num}`;
    } else {
      return `${num}`
    }
  }

  setImgStyle(event: Event) {
    // 可以通过 event.target 获取到加载完成的图片元素
    const img = event.target as HTMLImageElement;
    // 进行样式设置
    let naturalWidth = img.naturalWidth;
    let naturalHeight = img.naturalHeight;
    if (naturalWidth > naturalHeight) {
      //横着的长方形
      this.imgWidth = '100%';
      this.imgHeight = 'auto';
    } else if (naturalWidth < naturalHeight) {
      //竖着的长方形
      this.imgWidth = 'auto';
      this.imgHeight = '100%';
    }
  }

  mounted() {
    // 监听折扣类型变化事件
    EventBus.$on('discount-type-changed', (type: any) => {
      // console.log('discount-type-changed', type);
      // 更新本地formData中的discountType
      if (this.formData) {
        this.$set(this.formData, 'discountType', type);
        // 每次更新时增加计数器，强制计算属性重新计算
        this.discountTypeUpdated++;

        // 强制更新视图
        this.$forceUpdate();
      }
    });
  }

  handleCloseClick() {
    // 关闭按钮点击事件
    this.$emit('close-popup');
  }

  beforeDestroy() {
    EventBus.$off('discount-type-changed');
  }
}
